import React from 'react';
import { isTokenExpired } from '../util/CommonUtil';
import { Redirect } from 'react-router-dom';


const PermissionGate: React.FC<{ children: React.ReactNode; requiredRole: string }> = ({ children, requiredRole }) => {

  
   const token = localStorage.getItem('access_token'); // Or wherever you store your token
   
      if (token && isTokenExpired(token)) {
        // Clear any stored user data if necessary
        localStorage.removeItem('access_token');
        localStorage.removeItem('current_user');
        localStorage.removeItem('user_id');
        return <Redirect to="/login" />;
      } if (!token) {
        return <Redirect to="/login" />;
      }
   
    return <>{children}</>;
};

export default PermissionGate;